var animPromise,
	ajaxPromise,
	pathArray = location.href.split("/"),
	protocol = pathArray[0],
	host = pathArray[2],
	ajax_url = protocol + "//" + host + "/wp-admin/admin-ajax.php";

// function to defer current AJAX request by 600 milliseconds.
function wait() {
	var deferred = jQuery.Deferred();
	setTimeout(function () {
		deferred.resolve();
	}, 600);

	return deferred.promise();
}

function toggleAccountPolicies() {
    if($('.account-policies__wrapper').length) {
        var toggle = $('#account-policies-toggle');
        var target = '.account-policies__group.' + toggle.val();

        $(target).addClass('active');

        toggle.on('change', function() {
            var target = '.account-policies__group.' + $(this).val();

            if(!$(target).hasClass('active')) {
                $('.account-policies__group.active').removeClass('active');
                $(target).addClass('active');  
            }          
        });
    }
}

function toggleAccountEditableFields() {
    if($('.editable').length) {
        var toggle = $('.editable').find('.edit');

        toggle.on('click', function() {
            var inputs = $(this).siblings('input');
            var form = $(this).closest('form');

            inputs.removeClass('readonly');
            inputs.removeAttr('readonly');
            $(this).parent().removeClass('readonly');
            $(this).addClass('hidden');

            form.find('input').on('change', function() {
                form.find('.btn.disabled').removeClass('disabled');
            });
        });
    }
}

function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

function triggerDocument(currentItem) {
    currentItem.addClass('disabled');
    currentItem.find('.c__loader').addClass('active');

    var link = currentItem;
    var type = currentItem.data('type');
    var policy = currentItem.data('policy') ? currentItem.data('policy') : currentItem.data('addons');

    if(type){
        animPromise = wait();
        ajaxPromise = $.ajax({
            type: "POST",
            url: ajax_url,
            data: {
                action: "mw_collingwood_create_doc",
                type: type,
                policy: policy,
            },
            xhrFields: {
                responseType: "blob",
            },
            success: function (data) {
                if (data.constructor.name == "Blob") {
                    try {
                        if(isSafari) {
                            var a = document.createElement("a");
                            var url = window.URL.createObjectURL(data);
        
                            a.href = url;
                            a.download = type + '.pdf';
                            document.body.append(a);
                            a.click();
                            a.remove();
                        } else {
                            var url = window.URL.createObjectURL(data);
                            window.open(url, "_blank");
                        }
                    } catch (error) {
                        try {
                            var a = document.createElement("a");
                            var url = window.URL.createObjectURL(data);
        
                            a.href = url;
                            a.download = type + '.pdf';
                            document.body.append(a);
                            a.click();
                            a.remove();
                        } catch (error) {
                            console.error("An error occurred: ", error.message);
                            alert("Unable to open document");
                        }
                    }
                } else {
                    alert("Unable to open document");
                }
            },
            error: function () {
                alert("Unable to open document");
            },
        });
        $.when(animPromise, ajaxPromise).done(function () {	
            link.removeClass('disabled');
            link.find('.c__loader').removeClass('active');
        });
    }
}

function renewalHideAccidentConfirmation() {
    $(document).on('click', '.btn--renew.hide-accident-confirmation', function(e) {
        e.preventDefault();

        let target = $(this).attr('href');

        if(target) {
            let form = $(target).find('.a__form');

            form.trigger('submit');
        }
    });

    $(document).on('click', '.btn--renew.hide-new-question', function(e) {
        e.preventDefault();

        let target = $(this).attr('href');
        let hasLity = $(this).attr('data-lity');

        if(target && hasLity === undefined) {
            let form = $(target).find('.a__form');

            form.trigger('submit');
        }
    });
}

function renewalAdditionalDriverConfirmation() {
    $(document).on('click', '.btn--renewal.additional-driver', function(e) {
        e.preventDefault();

        var href = $(this).attr('href');

        $('.lity-close').trigger('click');

        if (href) {
            lity(href);
        }
    });

    $(document).on('change', '.a__renew.additional-driver .input-additional-driver[type="radio"]', function(e) {
        var additionalDriverInput = $(this).closest('.a__renew').find('.a__form--cld-renewal input[name="additional-driver"]');
        additionalDriverInput.val($(this).val());
    });

    // read the choice again on submit - the popup is moved in the DOM when it opens, so relying on the
    // change event alone can leave the hidden input holding its default of false.
    $(document).on('submit', '.a__renew.additional-driver .a__form--cld-renewal', function(e) {
        var selected = $(this).closest('.a__renew.additional-driver').find('.input-additional-driver[type="radio"]:checked').val();

        $(this).find('input[name="additional-driver"]').val(selected === 'true' ? 'true' : 'false');
    });
}

$(function() {
    $(document).on('lity:ready', function(event, $lightbox) {
        var $trigger = $lightbox.opener();
        
        if ($trigger.data('nominated')) {
            $('.lity-content').find('input[name="person_id"]').val($trigger.data('nominated'));
        }
    });

    $(document).on('click', '.a__link[data-policy]:not(.disabled), .a__link[data-addons]:not(.disabled)', function(e) {
		e.preventDefault();

        triggerDocument($(this));
    });

    $('#mta-close').on('click', function(){
        $('#mta').removeClass('active');
        $('input#fee').remove();
	});

    // The fee popup can also close via the backdrop, the close icon or ESC;
    // without this reset the form keeps its `active` class and stale fee token,
    // so the next submit would bypass vehicle validation entirely.
    $(document).on('lity:close', function () {
        if ($('#mta').hasClass('active')) {
            $('#mta').removeClass('active');
            $('input#fee').remove();
        }
    });

    $(document).on("submit", "#mta:not(.active)", function (e) {
        var form = $(this);
        var submitButton = form.find('button[type="submit"], input[type="submit"]');

        // A vehicle/fee check is already in flight for this form: discard the repeated click.
        if (form.data('mtaChecking')) {
            e.preventDefault();

            return false;
        }

        var result = window.validateForm(form);
        
        submitButton.addClass('loading');
    
		e.preventDefault();  

        if(!$('#car__registration_textarea').hasClass('active') && $('.quote-question__car-reg').length) {
            $("html, body").animate({
                scrollTop: $('.quote-question__car-reg').offset().top - 300
            }, 0);

            submitButton.removeClass('loading');
            
            return true;
        }

        var mtaaccidents = $(this).find('input[name="mta_accidents"]'); 
        
        if(mtaaccidents.length){
            mtaaccidents = $(this).find('input[name="mta_accidents"]:checked').val();  

            $('.mta_accidents .validation_error').remove() ;

            if(mtaaccidents == 'yes'){
                $( ".mta__accidents " ).append('<span class="validation_error">Unable to proceed, please contact us</span>'); 
                result = false;
            } else if(!mtaaccidents) { 
                $( ".mta__accidents").append('<span class="validation_error">Please select from one of the option</span>');
                result = false;
            } 
        }

        if(!result || result == false ) {
            submitButton.removeClass('loading');

			return true;
        }

        form.data('mtaChecking', true);
        submitButton.prop('disabled', true);

        var filtersObj = {},
			filtersVal = form.serializeArray();
 
        $('.mta_form > .c__loader').addClass('active');
    
        $.each(filtersVal, function (i, f) {
            if (filtersObj[f.name]) {
                filtersObj[f.name] += ',' + f.value;
            } else if (f.value) {
                filtersObj[f.name] = f.value;
            }
        }); 

        let changeOfVehicle = true;
        if(filtersObj.car__registration) {
            changeOfVehicle = false;
        }

        window.mwConsoleLog(filtersObj);

        if(filtersObj['car__registration-selection-type']) {
            animPromise = wait();
            ajaxPromise = $.ajax({
                type: 'POST',
                url: ajax_url,
                dataType: 'json',
                data: ({
                    'action': 'mw_collingwood_mta_vehicle_valid',
                    'data': filtersObj, 
                }),
                success: function (data) {
                    result = data; 
                }
            });
            $.when(animPromise, ajaxPromise).done(function () { 
                window.mwConsoleLog(result);

                if(result && result.ErrorMessages) {
                    submitButton.removeClass('loading');
                    submitButton.prop('disabled', false);
                    form.data('mtaChecking', false);

                    form.find('.c__loader').removeClass('active');

                    if($.isArray(result.ErrorMessages)) {
                        form.find('#mta-vehicle-popup .popup__inner-text').html(result.ErrorMessages[0]);
                    } else {
                        form.find('#mta-vehicle-popup .popup__inner-text').html(result.ErrorMessages);
                    }

                    lity("#mta-vehicle-popup");
                } else {
                    animPromise = wait();
                    ajaxPromise = $.ajax({
                        type: 'POST',
                        url: ajax_url,
                        dataType: 'json',
                        data: ({
                            'action': 'mw_collingwood_mta_fee',
                            'user_id': filtersObj.user_id,
                            'date': filtersObj.start_date, 
                            'registration': changeOfVehicle
                        }),
                        success: function (data) {
                            result = data; 
                        }
                    });
                    $.when(animPromise, ajaxPromise).done(function () { 
                        submitButton.removeClass('loading');
                        submitButton.prop('disabled', false);
                        form.data('mtaChecking', false);

                        form.addClass('active'); 
                        form.find('.c__loader').removeClass('active');

                        window.mwConsoleLog(result);

                        if(result && result.MTAFee != 0){
                            $('<input>', {
                                type: 'hidden',
                                id: 'fee',
                                name: 'fee',
                                value: result.token
                            }).appendTo('form');

                            $('#mta-fee .fee').text(result.MTAFee); 
                            lity('#mta-fee');
                        } else {
                            form.submit(); 
                        }
                    });
                }
            });
        } else {
            animPromise = wait();
            ajaxPromise = $.ajax({
                type: 'POST',
                url: ajax_url,
                dataType: 'json',
                data: ({
                    'action': 'mw_collingwood_mta_fee',
                    'user_id': filtersObj.user_id,
                    'date': filtersObj.start_date, 
                    'registration': changeOfVehicle
                }),
                success: function (data) {
                    result = data; 
                }
            });
            $.when(animPromise, ajaxPromise).done(function () { 
                submitButton.removeClass('loading');
                submitButton.prop('disabled', false);
                form.data('mtaChecking', false);

                form.addClass('active'); 
                form.find('.c__loader').removeClass('active');

                window.mwConsoleLog(result);

                if(result && result.MTAFee != 0){
                    $('<input>', {
                        type: 'hidden',
                        id: 'fee',
                        name: 'fee',
                        value: result.token
                    }).appendTo('form');

                    $('#mta-fee .fee').text(result.MTAFee); 
                    lity('#mta-fee');
                } else {
                    form.submit(); 
                }
            });
        }
	});  

    $(document).on("submit", 'form#signin', function (e) {

        // if(!window.validateForm($(this))) {
		// 	return false;
		// }   

        e.preventDefault();

        var $form = $(this),
            $submitBtn = $form.find('[type=submit]');

        // Sign-in already in progress: discard the repeated click (avoids multiple auth codes being sent).
        if ($form.data('submitting')) {
            return false;
        }

        $form.data('submitting', true);
        $submitBtn.prop('disabled', true);

        var animPromise, ajaxPromise, result,
            filtersObj = {},
			filtersVal = $form.serializeArray();

        $('#signin .c__loader').addClass('active');
		$('.c__message').removeClass( 'active' ).empty();
    
        $.each(filtersVal, function (i, f) {
            if (filtersObj[f.name]) {
                filtersObj[f.name] += ',' + f.value;
            } else if (f.value) {
                filtersObj[f.name] = f.value;
            }
        }); 

		var customer = false; 

		if( filtersObj.customer ){
			customer =  filtersObj.customer;
		}
    
        animPromise = wait();
        ajaxPromise = $.ajax({
            type: 'POST',
            url: ajax_url,
            dataType: 'json',
            data: ({
                'action': 'collingwood_signin_user',
				'username': filtersObj.username,
                'password': filtersObj.password, 
				'customer': customer, 
            }),
            success: function (data) {
                result = data; 

                if (result.redirect) {
                    window.location = result.redirect;                    
                    //window.location.reload();
                }
            },
            error: function () {
                $form.data('submitting', false);
                $submitBtn.prop('disabled', false);
                $('#signin .c__loader').removeClass('active');
            }
        });
        $.when(animPromise, ajaxPromise).done(function () { 
            $('#signin .c__loader').removeClass('active');

            if (!result.redirect) {
                $form.data('submitting', false);
                $submitBtn.prop('disabled', false);
            }

			if(result.html) { 
                $(this).find('.ajaxed').remove();

                if(result.multiauth) {
                    $('#signin').remove();
                    $('#signin-wrap').append(result.html);
                } else {
                    $('#signin .quote-question__wrapper').append(result.html);
                }

			}

            if(result.error) {
                $( ".c__message:not(.c__message--info)").addClass( 'active' ).text( result.error );
            }
        });
    });  

    $(document).on("submit", 'form#authcode', function (e) {
        e.preventDefault();

        var $form = $(this),
            $submitBtn = $form.find('[type=submit]');

        if ($form.data('submitting')) {
            return false;
        }

        $form.data('submitting', true);
        $submitBtn.prop('disabled', true);

        var animPromise, ajaxPromise, result,
            filtersObj = {},
			filtersVal = $form.serializeArray();

        $('#authcode .c__loader').addClass('active');
		$('.c__message').removeClass( 'active' ).empty();
    
        $.each(filtersVal, function (i, f) {
            if (filtersObj[f.name]) {
                filtersObj[f.name] += ',' + f.value;
            } else if (f.value) {
                filtersObj[f.name] = f.value;
            }
        }); 

        animPromise = wait();
        ajaxPromise = $.ajax({
            type: 'POST',
            url: ajax_url,
            dataType: 'json',
            data: ({
                'action': 'collingwood_signin_user_authcode',
				'code': filtersObj.code,
				'user': filtersObj.user, 
            }),
            success: function (data) {
                result = data; 

                if (result.redirect) {
                    window.location = result.redirect;                    
                    //window.location.reload();
                }
            },
            error: function () {
                $form.data('submitting', false);
                $submitBtn.prop('disabled', false);
                $('#authcode .c__loader').removeClass('active');
            }
        });
        $.when(animPromise, ajaxPromise).done(function () { 
            if(result.error){
                $( "#authcode .c__message:not(.c__message--info)").addClass( 'active' ).text( result.error );
                $('#authcode .c__loader').removeClass('active');
                $form.data('submitting', false);
                $submitBtn.prop('disabled', false);
            }
        });
    }); 

    $(document).on('change', 'select[name=policy__cancel_reasons]', function() {
        var parent = $(this).closest('form.cancel-policy');

        if($(this).val() == '1183') {
            parent.find('.cancel-policy__inner-checkbox').addClass('active');
            parent.find('.marketing-consent-content').addClass('active');
        } else {
            parent.find('.cancel-policy__inner-checkbox').removeClass('active');
            parent.find('.cancel-policy__inner-checkbox').find('input[name=marketing_consent]').prop('checked', false);
            parent.find('.marketing-consent-content').removeClass('active');
        }
    });

    $(document).on('click', '.trigger-cancel-policy', function(e) {
        var animPromise, ajaxPromise, result,
        filtersObj = {},
        targetID = $(this).attr('href'),
        targetForm = $(targetID).find('form.cancel-policy'),
        filtersVal = $(targetForm).serializeArray();

        $.each(filtersVal, function (i, f) {
            if (filtersObj[f.name]) {
                filtersObj[f.name] += ',' + f.value;
            } else if (f.value) {
                filtersObj[f.name] = f.value;
            }
        }); 

        animPromise = wait();
        ajaxPromise = $.ajax({
            type: 'POST',
            url: ajax_url,
            dataType: 'json',
            data: ({
                'action': 'collingwood_marketing_preferences',
                'data': filtersObj, 
            }),
            success: function (data) {
                result = data; 
            }
        });
        $.when(animPromise, ajaxPromise).done(function () {
            if(result.marketing) {
                var marketingDisplayedContent = $('<input type="hidden" id="marketing_submitted" name="marketing_submitted" value="true" />');
                $(targetForm).find('input[name=product_id').after(marketingDisplayedContent);

                if(result.marketing.display_marketing_opt_in_content) {
                    var marketingContent = $('<div />').html(result.marketing.display_marketing_opt_in_content);
                    $(targetForm).find('.cancel-policy__inner-content').html(marketingContent);
                }

                if(result.marketing.display_marketing_opt_in_checkbox_content) {
                    var marketingCheckboxContent = $('<input type="checkbox" id="marketing_consent" name="marketing_consent" /><label for="marketing_consent">' + result.marketing.display_marketing_opt_in_checkbox_content + '</label>');
                    var marketingBelowCheckboxContent = $('<div class="marketing-consent-content" />').html(result.marketing.display_marketing_opt_in_below_checkbox_content);

                    $(targetForm).find('.cancel-policy__inner-checkbox').html(marketingCheckboxContent);
                    $(targetForm).find('.cancel-policy__inner-checkbox').after(marketingBelowCheckboxContent);
                }
            }
        });
    });

    $(document).on("submit", 'form.cancel-policy', function (e) {
        var $form = $(this),
            $submitBtn = $form.find('[type=submit]');

        // Guard against repeated clicks: only one cancellation request per form at a time.
        if ($form.data('submitting')) {
            e.preventDefault();
            return false;
        }

        if(!window.validateForm($form)) {
			return false;
		}  
			
        e.preventDefault();

        $form.data('submitting', true);
        $submitBtn.prop('disabled', true).addClass('loading');

        var animPromise, ajaxPromise, result,
            filtersObj = {},
			filtersVal = $form.serializeArray();

            $form.find('.c__loader').addClass('active');
            $form.find('.c__message').removeClass( 'active' ).empty();
    
        $.each(filtersVal, function (i, f) {
            if (filtersObj[f.name]) {
                filtersObj[f.name] += ',' + f.value;
            } else if (f.value) {
                filtersObj[f.name] = f.value;
            }
        }); 
    
        animPromise = wait();
        ajaxPromise = $.ajax({
            type: 'POST',
            url: ajax_url,
            dataType: 'json',
            data: ({
                'action': 'collingwood_cancel_policy',
				'data': filtersObj, 
            }),
            success: function (data) {
                result = data; 
            },
            error: function () {
                // Request failed: allow the customer to try again.
                $form.data('submitting', false);
                $submitBtn.prop('disabled', false).removeClass('loading');
                $form.find('.c__loader').removeClass('active');
            }
        });
        $.when(animPromise, ajaxPromise).done(function () {
             if(result.myfirst && result.myfirst.data) {
                var confirmHtml = $('.policy-cancellation-confirm-message').html();
                var confirmHtml = confirmHtml + $('<textarea />').html(result.myfirst.data).text();

                $(this).find('.cancel-policy__myfirst').addClass('active');
                $(this).find('.cancel-policy__myfirst').html(confirmHtml);
                $(this).find('.cancel-policy__inner').addClass('hide');
                $(this).find(".c__loader").removeClass('active');
            } else if(result.message) {
                var confirmHtml = $('.policy-cancellation-confirm-message').html();
                var confirmHtml = confirmHtml + $('<textarea />').html(result.message).text();

                $(this).find('.cancel-policy__message').addClass('active');
                $(this).find('.cancel-policy__message').html(confirmHtml);
                $(this).find('.cancel-policy__inner').addClass('hide');
                $(this).find(".c__loader").removeClass('active');
            }
        });
    }); 

    function accountMyDetailsAddLoadingAnimation()
    {
        // Add loading animation for [Your Details] form submission.
        $('form#update-details, form#add-third-party, form#update-password, form#lost-username, form#lost-password').on('submit', function(e) {
            e.preventDefault(); // prevent default form submission
            const $form = $(this);

            // Request already in flight (page reloads once it completes): discard repeated clicks.
            if ($form.data('submitting')) {
                return false;
            }

            const formData = $form.serialize();

            $form.data('submitting', true);
            $form.find('button[type=submit]').addClass('loading').prop('disabled', true);

            $.post($form.attr('action'), formData)
                .done(function(response) {
                    window.mwConsoleLog('Form submitted successfully');

                    // Reload page and append success=true
                    var url = new URL(window.location.href);
                    url.searchParams.set('success', 'true');

                    let formId = $form.attr('id');

                    switch (formId) {
                        case 'update-password':
                            url = new URL('my-account', window.location.origin);
                            url.searchParams.set('success', '1');
                            url.searchParams.set('password', '1');

                            break;
                    }

                    window.location.href = url.toString();
                })
                .fail(function(error) {
                    console.error('Form submission failed');

                    var url = new URL(window.location.href);
                    url.searchParams.set('failed', 'true');
                    window.location.href = url.toString();
                })
                .always(function() {
                    $form.find('button[type=submit]').removeClass('loading');
                });
        });
    }

    accountMyDetailsAddLoadingAnimation();
    
    toggleAccountPolicies();

    toggleAccountEditableFields();

    renewalHideAccidentConfirmation();

    renewalAdditionalDriverConfirmation();
});